// Keep the dialog stable as filters expand; larger selections use its internal scroll.
export const DISCOUNT_DIALOG_BODY_HEIGHT = 136;
